import { FilterForm } from "./filter-form";

export function PrimaryControl() {
  return <FilterForm view="onlyPrimary" />;
}
